<template>
	<SubmissionFetchError
		v-if="errorMessage"
		:message="errorMessage"
	/>
	<TierAndEmailForm
		v-else-if="step === Steps.Tier"
		:email-error-status="emailErrorStatus"
		:plan-id="planId"
		:requested-account-tier="requestedAccountTier"
		:last-submitted-email="lastSubmittedEmail"
		@continue-to-payment="continueToPayment"
		@email-submit="emailSubmit"
	/>
	<PaymentForm
		v-else-if="step === Steps.Payment"
		:plan-id="planId"
		:purchase-amount="purchaseAmount"
		@payment-submitted="paymentSubmit"
	/>
</template>

<script setup lang="ts">
import { EverplansEmailStatusEnum } from '@/classes/SubmissionStatuses/types'
import PaymentForm from '@/components/home/SubmissionStatuses/ResubmissionModals/PaymentForm.vue'
import useResubmissionHelper from '@/components/home/SubmissionStatuses/ResubmissionModals/ResubmissionHelper'
import TierAndEmailForm from '@/components/home/SubmissionStatuses/ResubmissionModals/TierAndEmailForm.vue'
import SubmissionFetchError from '@/components/home/SubmissionStatuses/SubmissionFetchError.vue'
import { useEverplansResubmissionService } from '@/services/everplansResubmission'
import type { EverplansPayment } from '@/types'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

export type FixOrUpgradeProps = {
	planId: string
	emailErrorStatus: EverplansEmailStatusEnum
	requestedAccountTier?: string | null
	lastSubmittedEmail?: string | null
	purchaseAmount?: number
}

enum Steps {
	Tier = 'tier',
	Payment = 'payment',
}

const props = defineProps<FixOrUpgradeProps>()

const { t } = useI18n()

const step = ref<Steps>(Steps.Tier)

const email = ref<string>()

const emit = defineEmits(['closeModal'])

const { upgradeEverplansSubscription, updateEverplansEmail } =
	useEverplansResubmissionService()

const continueToPayment = (newEmail: string) => {
	email.value = newEmail
	step.value = Steps.Payment
}

const { errorMessage, setError } = useResubmissionHelper()

const paymentSubmit = async (payment: EverplansPayment) => {
	try {
		await upgradeEverplansSubscription(props.planId, payment, email.value)
		emit('closeModal')
	} catch (e) {
		setError(e)
	}
}

const emailSubmit = async (newEmail: string) => {
	try {
		await updateEverplansEmail(props.planId, newEmail)
		emit('closeModal')
	} catch (e) {
		setError(e)
	}
}
</script>

<style scoped></style>
